import { render, staticRenderFns } from "./EmpProviders.vue?vue&type=template&id=53826d5a&"
import script from "./EmpProviders.vue?vue&type=script&lang=js&"
export * from "./EmpProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports